import script from "./CardBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardBadge.vue?vue&type=script&setup=true&lang=ts"

import "./CardBadge.vue?vue&type=style&index=0&id=7cd52a87&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd52a87"]])

export default __exports__